import styled from 'styled-components'
import Row from 'components/Layout/Row'

export const AccomplishmentRow = styled(Row)`
  flex-wrap: wrap;
  row-gap: 0.5em;
`
